import { render, staticRenderFns } from "./index-admin.vue?vue&type=template&id=78061b10&scoped=true"
import script from "./index-admin.vue?vue&type=script&lang=js"
export * from "./index-admin.vue?vue&type=script&lang=js"
import style0 from "./index-admin.vue?vue&type=style&index=0&id=78061b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78061b10",
  null
  
)

export default component.exports